export const T = {
  en_GB: { startFailed: "Could not start the quiz. Please try again." },
  nb_NO: { startFailed: "Kunne ikke starte quizen. Prøv igjen." },
} as const;
